/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {OfferRichTextContent} from "./offerRichTextContent.zod";

export const OfferRichTextBlock = zod.object({
  blockId: zod.uuid(),
  blockType: zod.enum(["RICH_TEXT"]),
  content: OfferRichTextContent,
});

export type OfferRichTextBlock = zod.input<typeof OfferRichTextBlock>;
export type OfferRichTextBlockOutput = zod.output<typeof OfferRichTextBlock>;
